import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import React from "react";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { Loader, theme } from "components";
import "./index.css";
import store, { persistedStore } from "./store";
import { Logout } from "./pages/logout/logout";
import { Unauthorized } from "./pages/unauthorized/unauthorized";
import { tenantSettings } from "utils/authentication/tenantSettings";
import { isEmpty } from "lodash";
import "utils/i18n";
import { withLogging } from "utils/logger";
import { TenantAuthProvider } from "components/authentication/tenantAuthProvider";
import AttendanceFormApp from "AttendanceForm/App/AttendanceFormApp";
import { PersistGate } from "redux-persist/integration/react";
import { createRoot } from "react-dom/client";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const isAttendanceForm = window.location.pathname.includes("attendanceform");

// Create data router to enable useBlocker hook
const router = createBrowserRouter([
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "*",
    element: isEmpty(tenantSettings) ? (
      <Navigate to="/unauthorized" replace />
    ) : (
      <TenantAuthProvider children={null} />
    ),
  },
]);

const Component = (
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={<Loader isDisplay={true} type="page"></Loader>}
        persistor={persistedStore}
      >
        {!isAttendanceForm ? (
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <StylesThemeProvider theme={theme}>
                <RouterProvider router={router} />
              </StylesThemeProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        ) : (
          AttendanceFormApp
        )}
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

const Root = withLogging(() => Component);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(Root);
}
